<template>
  <div style="display: none">
    <slot></slot>
  </div>
</template>

<script>
import { findRealParent, propsBinder } from "vue2-leaflet";
import L from "leaflet";
import "leaflet.idw";

const props = {
  latLng: {
    type: Array,
    default: () => [],
    custom: false,
  },
  bounds: {
    default: null,
  },
  discrete: {
    type: Boolean,
    default: false,
  },
  discreteGradient: {
    type: Array,
    default: () => [
      [69, 117, 180],
      [116, 173, 209],
      [171, 217, 233],
      [224, 243, 248],
      [254, 224, 144],
      [253, 174, 97],
      [244, 109, 67],
      [215, 48, 39],
    ],
    custom: true,
  },
  opacity: {
    type: Number,
    custom: true,
    default: 0.5,
  },
  max: {
    type: Number,
    custom: true,
    default: 1.0,
  },
  cellSize: {
    type: Number,
    custom: true,
    default: 10,
  },
  exp: {
    type: Number,
    custom: true,
    default: 10,
  },
  // Viridis
  gradient: {
    type: Object,
    default: () => ({
      0: "#313695",
      0.1: "#4575b4",
      0.2: "#74add1",
      0.3: "#abd9e9",
      0.4: "#e0f3f8",
      0.5: "#ffffbf",
      0.6: "#fee090",
      0.7: "#fdae61",
      0.8: "#f46d43",
      0.9: "#d73027",
      1: "#a50026",
    }),
  },
  visible: {
    type: Boolean,
    custom: true,
    default: true,
  },
};
export default {
  name: "LInterpolation",
  components: {},
  mixins: [],
  props,
  data() {
    return {
      ready: false,
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    const options = {};
    if (this.opacity) {
      options.opacity = this.opacity;
    }
    // if (this.max) {
    //   options.max = this.max;
    // }

    // options.max = 1;
    if (this.cellSize) {
      options.cellSize = this.cellSize;
    }
    if (this.exp) {
      options.exp = this.exp;
    }
    if (this.gradient) {
      options.gradient = this.gradient;
    }
    if (this.discreteGradient) {
      options.discreteGradient = this.discreteGradient;
    }
    if (this.discrete) {
      options.discrete = this.discrete;
    }
    if (this.bounds) {
      options.bounds = this.bounds;
    }
    this.mapObject = L.idwLayer(this.latLng, options);
    L.DomEvent.on(this.mapObject, this.$listeners);
    propsBinder(this, this.mapObject, props);
    this.ready = true;
    this.parentContainer = findRealParent(this.$parent);
    this.$nextTick(() => {
      this.parentContainer.addLayer(this, !this.visible);
    });
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    this.parentContainer.removeLayer(this);
  },
  destroyed() {},
  methods: {
    setOptions(newVal) {
      this.mapObject.setOptions(newVal);
    },
    setCellSize(newVal) {
      this.mapObject.setOptions({ cellSize: newVal });
    },
    setGradient(newVal) {
      this.mapObject.setOptions({ gradient: newVal });
    },
    addLatLng(value) {
      this.mapObject.addLatLng(value);
    },
    setLatLngs(values) {
      this.mapObject.setLatLngs(values);
    },
    redraw() {
      this.mapObject.redraw();
    },
    setVisible(newVal, oldVal) {
      if (newVal === oldVal) return;
      if (newVal) {
        this.parentContainer.addLayer(this);
      } else {
        this.parentContainer.removeLayer(this);
      }
    },
  },
};
</script>

<style></style>
